import type WaveSurfer from 'wavesurfer.js'

let activeWaveSurfer: WaveSurfer | null = null

export function playOnlyOne(ws: WaveSurfer) {
    if (activeWaveSurfer && activeWaveSurfer !== ws) {
        activeWaveSurfer.pause()
    }

    activeWaveSurfer = ws
    ws.play()
}

export function clearActiveWaveSurfer(ws: WaveSurfer) {
    if (activeWaveSurfer === ws) {
        activeWaveSurfer = null
    }
}